<!--- Formulario FrmAccessDeviceActivity ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-access-device-details">
    <template #fixed>
      <TheNavbar
        nav-title="Detalle dispositivo de acceso"
        back-btn-enable
      />
    </template>

    <PCAccessDeviceDetail :selected-access-device="selectedAccessDevice" />
    <f7-block>
      <UCSearchEntityERP
        :title="$t('searchEntity.productionActivity.title.configuredProductionActivity')"
        :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
        :search-text="$t('searchEntity.productionActivity.searchText')"
        :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
        :default-value="initialactivityDevice"
        :end-point-for-code-search="ActivityCodeSearch"
        :end-point-for-list="ActivityList"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        @selection="EventSelectedProductionActivity"
      />
    </f7-block>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { usePresenceStore } from '@/js/stores/presence';

// import eventBus from '@/js/event-bus';
import TheNavbar from '@/components/TheNavbar.vue';
import {
  Log,
  LogError,
} from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import PCAccessDeviceDetail from '@/components/production/devices/PCAccessDeviceDetail.vue';
import APIErp from '@/js/services/APIErp';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';

export default {
  name: 'FrmAccessDeviceDetails',
  components: {
    UCSearchEntityERP,
    PCAccessDeviceDetail,
    TheNavbar,
  },

  data() {
    return {
      initialactivityDevice: null,
    };
  },
  computed: {
    ...mapWritableState(usePresenceStore, ['selectedAccessDevice']),
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.initialactivityDevice = this.selectedAccessDevice.ActividadProduccion;
    },

    ActivityCodeSearch(params) {
      Log(this, this.ActivityCodeSearch.name);
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      Log(this, this.ActivityList.name);
      // return APIErp.callProductionActivityList();
      return APIErp.callProductionActivityListAuthorized();
    },
    EventSelectedProductionActivity(objActivity) {
      Log(this, this.EventSelectedProductionActivity.name);
      if (objActivity == null) {
        return;
      }
      if (this.selectedAccessDevice.ActividadProduccion.Id !== objActivity.Id) {
        this.selectedAccessDevice.ActividadProduccion = objActivity;
        this.AssignProductionActivity();
      }
    },
    AssignProductionActivity() {
      Log(this, this.AssignProductionActivity.name);
      HiDialog.Preloader(true, 'Cambiando actividad de producción', true, 'Operación cancelada');
      this.Conections_ChangeActivityProductionDevice([this.selectedAccessDevice])
        .catch((error) => {
          HiNotification.Toast(error);
        })
        .finally(() => {
          HiDialog.Preloader(false);
        });
    },

    Conections_ChangeActivityProductionDevice(listObjDispositives) {
      return new Promise((resolve, reject) => {
        APIErp.callChangeActivityProductionDevice(listObjDispositives).then((result) => {
          resolve(result.data);
        })
          .catch((error) => {
            reject(error);
            LogError(this, this.Conections_ChangeActivityProductionDevice.name, error);
          });
      });
    },
  },

};
</script>

<style lang="scss">
.main-access-device-details {
  .page-content {
    background-color: #f2f2f2;
  }
}

.md .fab[class*="-bottom"],
.ios .fab[class*="-bottom"] {
  position: fixed;
}
</style>
